const parseBool = (value?: string) => {
	return value === 'true';
};

export const TEST_ENV = {
	TEST_TX_FORWARDING: parseBool(process.env.NEXT_PUBLIC_TEST_TX_FORWARDING),
};
